import antdData from 'antd/lib/locale-provider/de_DE'
import localeData from 'react-intl/locale-data/de'
import countries from './countries/de.json'
import languages from './languages/de.json'
import platform from './platform/de.json'
import urls from './urls/de.json'
import texts from './texts/de.json'
import faq from './faq/de.json'

export default {
  locale: 'de',
  antdData,
  localeData,
  messages: { ...texts, ...countries, ...languages, ...platform, ...urls, ...faq },
}
